// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_Fl4","cls2":"ReportList-cls2__HE ReportList-cls1_Fl4"};